import React from "react";
import { Outlet } from "react-router-dom";
import { PublicNav, Footer } from "@/components/marketing/PublicChrome";

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <Outlet />
      <Footer />
    </div>
  );
}
